import { Component, EventEmitter, Output, inject } from '@angular/core';

import { SalesOpportunitiesTrackerComponent } from '../sales-opportunities-tracker/sales-opportunities-tracker.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'opportunities-btn',
  standalone: true,
  imports: [],
  templateUrl: './opportunities-btn.component.html',
  styleUrls: ['./opportunities-btn.component.scss'],
})
export class OpportunitiesBtnComponent {
  @Output() clicked = new EventEmitter<void>();

  private dialog = inject(MatDialog);

  onClick(): void {
    this.dialog.open(SalesOpportunitiesTrackerComponent, {
      width: '90vw',
      maxWidth: '900px',
      height: 'auto',
      maxHeight: '90vh',
      panelClass: 'opportunities-tracker-dialog',
    });
  }
}
